export default "__VITE_ASSET__970c01b7__"